import { eventsAuthenticatedAxios } from '@/api/axios'
import axios from '@/api/axios'
import { useHostNameStore } from '@/stores/useHostNameStore'
import type { GetUserByIdWithStateResponse, User } from '@/types'

export async function getUserById(id: string, email: string) {
   const hostNameStore = useHostNameStore()
   const normalizedEmail = encodeURIComponent(email)
    
    const { data } = await eventsAuthenticatedAxios.get<GetUserByIdWithStateResponse>(
        `users/${id}/state/${hostNameStore.hostname}?email=${normalizedEmail}`
    )
    return data
}

export async function addNewUser(userId: string) {
    await axios.post(`users`, {
        adB2cId: userId
    })
}

export async function deleteUser(id: string) {
    const { data } = await axios.delete(
        `users/${id}`
    )
    return data
}

export async function updateUserAsync(user: User) {
    const { data } = await axios.put(
        `users`,
        user
    )
    return data
}
